var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$locale['object']['about-main-banner'])?_c('main',{staticClass:"about-container"},[_c('GlobalMainBanner',{attrs:{"bannerData":_vm.$locale['object']['about-main-banner']}}),_c('AboutWeAre'),_c('AboutIdentity'),_c('ServicesValues')],1):_c('Spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }